<template>
  <div class="repair-order" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>工单号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入工单号" v-model="table.search.number"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>报修项目</p>
          </a-col>
          <a-col>
            <a-cascader class="app-block" v-model="table.search.project" :options="projectOptions" placeholder="请选择报修项目"></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>报修时间</p>
          </a-col>
          <a-col>
            <a-range-picker v-model="table.search.date" show-time class="app-block" valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>报修人员</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入报修人或报修电话" v-model="table.search.keywords"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>工单状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择工单状态">
              <a-select-option :value="1">{{repairOrderStatusText(1)}}</a-select-option>
              <a-select-option :value="2">{{repairOrderStatusText(2)}}</a-select-option>
              <a-select-option :value="3">{{repairOrderStatusText(3)}}</a-select-option>
              <a-select-option :value="4">{{repairOrderStatusText(4)}}</a-select-option>
              <a-select-option :value="7">{{repairOrderStatusText(7)}}</a-select-option>
              <a-select-option :value="5">{{repairOrderStatusText(5)}}</a-select-option>
              <a-select-option :value="6">{{repairOrderStatusText(6)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
          <a-button @click="exportTable">导出</a-button>
          <!-- <a target="_blank" :href="$exportUrl(`/property_repair/repair_order_export?community_id=${communityId}&`)">
            <a-button>导出</a-button>
          </a> -->
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newOrder()">新增报修工单</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="repair_order_id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="orderInfo(data)">详情</a-button>
          <a-button type="link" @click="cancelOrder(data)" v-if="data.repair_order_state === 1 || data.repair_order_state === 2 || data.repair_order_state === 3">取消订单</a-button>
          <a-button type="link" @click="setPayOrder(data)" v-if="data.repair_order_state === 4 && !data.repair_order_pay_status">设为已缴</a-button>
          <a-button type="link" @click="evaluateOrder(data)" v-if="data.repair_order_state === 5" :disabled="!!data.repair_order_comment_datetime">评价订单</a-button>
          <a-button type="link" @click="assignOrder(data)" v-if="data.repair_order_state === 1 || data.repair_order_state === 2">分配</a-button>
          <a-button type="link" @click="urgeOrder(data)" v-if="data.repair_order_state === 2 && !data.repair_order_urgent_status">催办</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close centered>
      <a-form-model ref="form" :model="modal.form" layout="vertical" :rules="modal.rules">
        <a-form-model-item label="取消原因" prop="cancel">
          <a-select v-model="modal.form.cancel" placeholder="请选择取消原因">
            <a-select-option :value="value.repair_cancel_order_reason_id" v-for="value in cancelOptions" :key="value.repair_cancel_order_reason_id">{{value.cancel_order_reason}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="peopleModal.title" :confirm-loading="peopleModal.loading" v-model="peopleModal.show" @ok="confirmPeopleModal" destroy-on-close centered>
      <a-form-model ref="form" :model="peopleModal.form" layout="vertical" :rules="peopleModal.rules">
        <a-form-model-item label="维修人员" prop="people">
          <a-select mode="multiple" v-model="peopleModal.form.people" placeholder="请选择维修人员">
            <a-select-option :value="value.repair_attendant_id" v-for="value in peopleOptions" :key="value.repair_attendant_id">{{value.repair_attendant_name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="evaluateModal.title" :confirm-loading="evaluateModal.loading" v-model="evaluateModal.show" @ok="confirmEvaluateModal" destroy-on-close centered>
      <a-form-model ref="form" :model="evaluateModal.form" layout="vertical" :rules="evaluateModal.rules">
        <a-form-model-item label="评价内容" prop="content">
          <a-textarea v-model="evaluateModal.form.content" placeholder="请输入服务评价"></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="处理速度" prop="starOne">
          <a-space><a-rate v-model="evaluateModal.form.starOne" :allow-clear="false"></a-rate>{{evaluateModal.form.starOne}}星</a-space>
        </a-form-model-item>
        <a-form-model-item label="服务态度" prop="starTwo">
          <a-space><a-rate v-model="evaluateModal.form.starTwo" :allow-clear="false"></a-rate>{{evaluateModal.form.starTwo}}星</a-space>
        </a-form-model-item>
        <a-form-model-item label="维修专业度" prop="starThree">
          <a-space><a-rate v-model="evaluateModal.form.starThree" :allow-clear="false"></a-rate>{{evaluateModal.form.starThree}}星</a-space>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import {
    repairOrderStatusText
  } from '@/io/dict.js';
  import RepairItemsService from '@/io/repair_items.js';
  import RepairOrderService from '@/io/repair_order.js';
  import PeopleConfigService from '@/io/people_config.js';
  import CancelReasonService from '@/io/cancel_reason.js';

  export default {
    name: 'RepairOrder',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        repairOrderStatusText,
        projectOptions: [],
        peopleOptions: [],
        table: {
          loading: false,
          search: {
            number: null,
            project: [],
            date: [],
            keywords: null,
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '工单号',
              dataIndex: 'repair_order_no'
            },
            {
              title: '报修项目',
              dataIndex: 'repair_item_info.repair_item_title'
            },
            {
              title: '上门时间',
              dataIndex: 'repair_order_booking_datetime'
            },
            {
              title: '报修位置',
              dataIndex: 'position'
            },
            {
              title: '报修人员',
              dataIndex: 'people'
            },
            {
              title: '业主联系电话',
              dataIndex: 'repair_order_contact_phone'
            },
            {
              title: '维修人员',
              dataIndex: 'repairPeople'
            },
            {
              title: '工单状态',
              dataIndex: 'repairOrderStatusText'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        cancelOptions: [],
        modal: {
          id: null,
          title: '取消订单',
          show: false,
          loading: false,
          form: {
            cancel: []
          },
          rules: {
            cancel: [
              {
                required: true,
                message: '请选择取消原因'
              }
            ]
          },
        },
        evaluateModal: {
          id: null,
          title: '评价订单',
          show: false,
          loading: false,
          form: {
            content: null,
            starOne: 5,
            starTwo: 5,
            starThree: 5
          },
          rules: {
            content: [
              {
                required: true,
                message: '请填写服务评价'
              }
            ],
            starOne: [
              {
                required: true,
                message: '请选择处理速度星级'
              }
            ],
            starTwo: [
              {
                required: true,
                message: '请选择服务态度星级'
              }
            ],
            starThree: [
              {
                required: true,
                message: '请选择维修专业度星级'
              }
            ]
          },
        },
        peopleModal: {
          id: null,
          title: '分配',
          show: false,
          loading: false,
          form: {
            people: []
          },
          rules: {
            people: [
              {
                required: true,
                message: '请选择维修人员'
              }
            ]
          },
        },
      }
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            Promise.all([
              this.initProject(),
              this.initPeople(),
              this.initCancel()
            ]).then(() => {
              this.searchTable();
            });
          }
        },
        immediate: true
      }
    },
    activated () {
      if (this.communityId) {
        Promise.all([
          this.initProject(),
          this.initPeople(),
          this.initCancel()
        ]).then(() => {
          this.initData();
        });
      }
    },
    methods: {
      newOrder() {
        this.table.page.current = 1;
        let params = {
          name: 'NewRepairOrder'
        };
        if (this.communityId) {
          params.query = {
            community_id: this.communityId
          }
        }
        this.$router.push(params);
      },
      orderInfo(data) {
        this.$router.push({
          name: 'RepairOrderDetail',
          params: {
            id: data.repair_order_id
          },
          query: {
            community_id: this.communityId
          }
        });
      },
      cancelOrder(data) {
        this.modal.id = data.repair_order_id;
        this.modal.show = true;
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.modal.loading = true;
          RepairOrderService.cancel(this.modal.id, this.modal.form.cancel).then(res => {
            this.$afterFormSubmit('分配成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.modal.loading = false;
            this.modal.show = false;
            this.modal.form = {
              cancel: []
            };
          });
        });
      },
      setPayOrder(data) {
        RepairOrderService.setPay(data.repair_order_id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      urgeOrder(data) {
        RepairOrderService.urge(data.repair_order_id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      evaluateOrder(data) {
        this.evaluateModal.id = data.repair_order_id;
        this.evaluateModal.show = true;
      },
      confirmEvaluateModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.evaluateModal.loading = true;
          RepairOrderService.evaluate(this.evaluateModal.id, this.evaluateModal.form.content, this.evaluateModal.form.starOne, this.evaluateModal.form.starTwo, this.evaluateModal.form.starThree).then(res => {
            this.$afterFormSubmit('评价成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.evaluateModal.loading = false;
            this.evaluateModal.show = false;
            this.evaluateModal.form = {
              content: null,
              starOne: 5,
              starTwo: 5,
              starThree: 5
            };
          });
        });
      },
      assignOrder(data) {
        this.peopleModal.id = data.repair_order_id;
        this.peopleModal.show = true;
      },
      confirmPeopleModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.peopleModal.loading = true;
          RepairOrderService.assign(this.communityId, this.peopleModal.id, this.peopleModal.form.people).then(res => {
            this.$afterFormSubmit('分配成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.peopleModal.loading = false;
            this.peopleModal.show = false;
            this.peopleModal.form = {
              people: []
            };
            this.$store.dispatch('isNewRepair');
          });
        });
      },
      initPeople() {
        return PeopleConfigService.list(this.communityId).then(res => {
          this.peopleOptions = res.map(val => {
            return {
              ...val,
              repair_attendant_name: `${val.repair_attendant_name}(${val.repair_attendant_phone})`
            }
          });
        }).catch(err => {});
      },
      initProject() {
        let projectOptions = []; 
        return RepairItemsService.type().then(res => {
          projectOptions = res.repair_types.map(val => {
            val.label = val.name;
            val.children = [];
            return val;
          });
          return RepairItemsService.list(this.communityId || this.$getCookie('communityId'));
        }).then(res => {
          projectOptions.forEach((value, index) => {
            value.children = res.filter(val => val.repair_item_type === value.value).map(val => {
              val.label = val.repair_item_name;
              val.value = val.repair_items_id;
              val.parentId = value.value;
              return val;
            });
          });
          this.projectOptions = projectOptions.filter(val => val.children.length);
        }).catch(err => {});
      },
      initCancel() {
        return CancelReasonService.list().then(res => {
          this.cancelOptions = res;
        }).catch(err => {});
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          number: null,
          project: [],
          date: [],
          keywords: null,
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        RepairOrderService.listPage(
          this.communityId,
          this.table.search.number,
          this.table.search.project[0],
          this.table.search.project[1],
          this.table.search.date[0],
          this.table.search.date[1],
          this.table.search.keywords,
          this.table.search.status === 7 ? 5 : this.table.search.status,
          this.table.search.status === 7 ? 1 : (this.table.search.status === 4 ? 0 : 2),
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.position = val.repair_order_type === 1 ? val.repair_order_location : val.housing_info.full_name;
            val.repairOrderStatusText = repairOrderStatusText(val.repair_order_state === 4 && val.repair_order_pay_status ? 7 : val.repair_order_state);
            val.people = val.admin_user_id ? val.admin_user_name : val.repair_order_contact_name;
            val.repairPeople = val.attendants.map(val => val.repair_attendant_name).join('、');
            return val;
          });
          this.table.page.total = res.total;
          this.$emit('total', res.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
      exportTable() {
        RepairOrderService.exportList(
          this.communityId,
          this.table.search.number,
          this.table.search.project[0],
          this.table.search.project[1],
          this.table.search.date[0],
          this.table.search.date[1],
          this.table.search.keywords,
          this.table.search.status === 7 ? 5 : this.table.search.status,
          this.table.search.status === 7 ? 1 : (this.table.search.status === 4 ? 0 : 2)
        )
      }
    },
  }
</script>

<style lang="less" scoped>

</style>